<section class="relative min-h-[100dvh] bg-white bg-ha-gradient flex items-center justify-center">
  <div class="fixed inset-0 pointer-events-none select-none opacity-50">
    <svg viewBox="0 0 1680 1373" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg"
      class="w-full h-full">
      <path
        d="M894.499 1667H10.3878C-119.782 1667 -226 1560.98 -226 1431.05V559.999C-226 237.774 32.2563 -31.4402 348.829 -40.7952C510.239 -44.9529 662.277 14.295 777.867 126.554C878.879 225.301 940.319 353.151 953.856 491.397C1248.56 525.698 1480.78 771.005 1484.95 1068.28C1487.03 1228.36 1426.63 1378.04 1315.21 1492.37C1203.78 1604.63 1053.83 1667 894.499 1667ZM365.49 144.225C361.325 144.225 358.201 144.225 354.035 144.225C136.392 150.461 -39.5972 336.521 -39.5972 558.96V1430.01C-39.5972 1458.07 -16.6875 1480.94 11.4292 1480.94H894.499C1003.84 1480.94 1106.94 1438.32 1184 1360.37C1261.06 1282.41 1301.67 1179.5 1300.63 1070.36C1297.5 872.87 1147.55 709.678 953.856 677.456C942.401 851.042 899.706 1030.86 761.206 1170.15C585.216 1345.81 370.697 1314.63 248.858 1194.06C128.061 1073.48 96.8204 858.318 272.81 682.653C412.351 543.369 598.754 501.791 767.454 490.357C754.957 403.044 713.303 321.968 648.739 258.563C571.679 184.763 471.709 144.225 365.49 144.225ZM766.412 676.416C596.671 689.929 485.246 732.546 404.02 813.622C310.298 907.172 323.836 1005.92 380.069 1062.05C409.227 1091.15 446.716 1106.74 486.288 1106.74C534.19 1106.74 583.134 1082.84 628.953 1038.14C710.179 958.104 752.875 845.845 766.412 676.416Z"
        fill="url(#paint0_radial)" />
      <defs>
        <radialGradient id="paint0_radial" cx="0" cy="0" r="1"
          gradientTransform="matrix(-1240.52 -4.83701 1584.21 -2298.78 741.285 378.583)"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#DAD6FB" />
          <stop offset="1" stop-color="#DAD6FB" />
        </radialGradient>
      </defs>
    </svg>
  </div>

  <div class="relative z-10 flex flex-col items-center w-full max-w-sm p-4 md:p-10">
    <div class="mb-6 flex justify-center">
      <svg width="70" height="24" viewBox="0 0 70 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.70154 24H0.5V0H6.70154V24Z" fill="black" />
        <path d="M25.6055 17.8392L33.8004 0H40.2677L28.6177 24H22.3276L10.7218 0H17.4106L25.6055 17.8392Z"
          fill="black" />
        <path
          d="M52.3129 13.9126L41.3716 0H48.5476L55.5908 9.51199L62.634 0H69.5L58.4258 13.9126V24H52.3129V13.9126Z"
          fill="black" />
      </svg>
    </div>

    <div class="w-full">
      <div class="rounded-2xl bg-white shadow-xl ring-1 ring-black/5">
        <div class="px-6 py-8 sm:px-8">
          <div class="mb-6">
            <h2 class="text-xl font-bold">Create an account</h2>
            <p class="mt-2 text-xs text-gray-600">
              Please fill in your name, email and create password.
              <span class="whitespace-nowrap">Already have an account?
                <a routerLink="/login"
                  class="font-medium text-[#5D38F1] hover:text-violet-800 underline cursor-pointer">Login</a>
              </span>
            </p>
          </div>

          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="space-y-4">
            <div>
              <label for="name" class="mb-1 block text-sm font-medium">Name</label>
              <input id="name" type="text" formControlName="name" placeholder="First name"
                class="block w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 outline-none transition focus:border-gray-400 focus:ring-0" />
            </div>

            <div>
              <label for="email" class="mb-1 block text-sm font-medium">E-mail</label>
              <input id="email" type="email" formControlName="email" placeholder="email@example.com"
                class="block w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 outline-none transition focus:border-gray-400 focus:ring-0" />
            </div>

            <div>
              <div class="mb-1 flex items-center justify-between">
                <label for="password" class="block text-sm font-medium">Password</label>
              </div>
              <input id="password" type="password" formControlName="password" placeholder="Type password"
                class="block w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 outline-none transition focus:border-gray-400 focus:ring-0" />
            </div>

            <button type="submit" [disabled]="registerForm.invalid || isLoading"
              class="inline-flex w-full items-center justify-center rounded-full bg-[#2F2A4A] px-4 text-sm font-semibold text-white transition disabled:cursor-not-allowed disabled:opacity-60 h-[45px] mb-14">
              {{ isLoading ? 'Creating account...' : 'SIGN UP' }}
            </button>

            <p class="mt-2 text-xs text-center text-gray-500">
              By clicking below, you agree to our
              <a href="https://legal.stringhealth.ai/terms-of-use.html"
                class="text-[#5D38F1] hover:text-violet-800 underline">Terms of Service</a>,
              <a href="https://legal.stringhealth.ai/privacy-policy.html"
                class="text-[#5D38F1] hover:text-violet-800 underline">Cookies Policy</a>, and
              <a href="https://legal.stringhealth.ai/privacy-policy.html"
                class="text-[#5D38F1] hover:text-violet-800 underline">Privacy Policy</a>.
            </p>
          </form>

          <div *ngIf="registerError" class="mt-4 text-center text-sm text-red-500">
            {{ registerError }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex md:hidden fixed bottom-0 left-0 w-full h-[50px] bg-transparent items-center justify-center z-20">
    <p class="text-xs text-gray-500">
      © 2025 String Health Inc. All rights reserved.
    </p>
  </div>

  <div class="hidden md:flex fixed bottom-0 left-0 w-full h-[50px] bg-white items-center justify-center z-20">
    <p class="text-xs text-gray-500">
      © 2025 String Health Inc. All rights reserved.
    </p>
  </div>
</section>
